module.exports = __webpack_public_path__ + "sunset2.b0c0fd825c58236a6399.jpg";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/node_modules/@ngx-ivengi/cleanzone/theme/images/cleanzone/sunset2.jpg
// module id = ../../../../@ngx-ivengi/cleanzone/theme/images/cleanzone/sunset2.jpg
// module chunks = styles